<template>
  <div class="chatbot-answer-choices-vertical-wrapper">
    <div
      class="chatbot-answer-choices-vertical"
      :style="{ borderColor: config.choicesColor }"
    >
      <button
        v-for="choice in choices"
        :key="choice.id"
        v-on:click="sendChoiceAnswer(choice)"
        :style="{
          borderColor: config.choicesColor,
          color: config.choicesColor
        }"
      >
        {{ choice.displayText }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "AnswerChoicesVertical",
  computed: {
    ...mapState("messages", ["choices"]),
    ...mapState("settings", ["config"])
  },
  methods: {
    ...mapActions("messages", ["sendChoiceAnswer"])
  }
};
</script>

<style lang="scss" scoped>
.chatbot-answer-choices-vertical-wrapper {
  margin: 0 -15px;

  .chatbot-answer-choices-vertical {
    display: block;
    overflow: auto;
    white-space: nowrap;
    margin-top: 5px;
    border-radius: 10px;
    border-top-left-radius: 0;
    border: 1px solid;
    width: fit-content;
    width: 80%;
    margin-left: 15px;

    button {
      display: block;
      width: 100%;
      border: 0;
      outline: 0;
      padding: 12px;
      min-width: 39px;
      background-color: white;
      white-space: break-spaces;
      cursor: pointer;

      & + button {
        border-top: 1px solid;
      }
    }
  }
}
</style>
